import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'antd';
import axios from 'axios';
import getFormData from 'get-form-data';

import PhoneChangeSuccess from './PhoneChangeSuccess';

import { fieldValidation, fieldChange, responseError } from 'FIELDS';
import { InputsSet } from 'INPUTS';
import { Strings } from 'HELPERS';
import api from 'API';
import { tConsume } from 'TRANSLATION';
import defaults from 'DEFAULTS';

class PhoneChange2step extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      form: 'phoneChange_code',
      success: false,
      counter: defaults.timer,
      data: {},
      code: {
        name: 'code',
        type: 'number',
        accept: defaults.re.digits,
        required: true,
        placeholder: true,
      },
    };

    this._counterInterval = null;

    this.handleFieldChange = fieldChange.bind(this, this);
    this.fieldValidation = fieldValidation.bind(this, this);
    this.responseError = responseError.bind(this, this);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.resendCode = this.resendCode.bind(this);
    this.resetCounter = this.resetCounter.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.resetCounter();
  }

  componentWillUnmount() {
    this._mounted = false;
    clearInterval(this._counterInterval);
  }

  toggleModal(visible = !this.state.visible, response) {
    this.setState({ visible });

    if (!visible) {
      this.props.toggleModal(false, response);
    }
  }

  resetCounter(counter = defaults.timer) {
    this.setState({ counter: counter });

    this._counterInterval = setInterval(() => {
      this.setState({ counter: --counter });

      if (counter === 0) {
        clearInterval(this._counterInterval);
      }
    }, 1000);
  }

  handleSubmit(event) {
    event.preventDefault();

    const data = {
      ...this.props.data,
      ...this.state.data,
      ...getFormData(event.target, { trim: true }),
    };

    const { userType } = this.props;

    if (this.fieldValidation()) {
      this.setState({
        loading: true,
      });

      axios(api.users.profile.changePhoneVerify(userType).AXIOS('POST', data))
        .then((response) => {
          if (this._mounted) {
            this.setState({
              success: true,
              data: data,
            });

            this.toggleModal(false, response);
          }
        })
        .catch((error) => {
          if (this._mounted) {
            this.responseError(error);
          }
        })
        .finally(() => {
          if (this._mounted) this.setState({ loading: false });
        });
    }
  }

  resendCode(event) {
    const { data, confirmationCodeRequest } = this.props;

    confirmationCodeRequest(event, data);
    this.resetCounter();
  }

  render() {
    const { loading, success, data, counter } = this.state;
    const { t } = this.props;

    if (success) {
      return <PhoneChangeSuccess data={data} />;
    }

    return (
      <Form onSubmit={this.handleSubmit}>
        <p className='align-center'>{t('component.phoneNumber.confirmCode')}</p>

        {InputsSet(this, ['code'])}

        <p className='align-center mb20 textDescription' style={{ marginBottom: 50 }}>
          {`${Strings.Compile(t('component.email.descriptionResent'), [counter])} `}
          <a onClick={this.resendCode} disabled={counter !== 0}>
            {t('component.phoneNumber.reSend')}
          </a>
        </p>

        <Button
          type='primary'
          htmlType='submit'
          size={defaults.antd.button.size}
          loading={loading}
          className='mb20'
          block
        >
          {t('button.continue')}
        </Button>
      </Form>
    );
  }
}

export default tConsume(PhoneChange2step);

PhoneChange2step.propTypes = {
  userType: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  toggleModal: PropTypes.func.isRequired,
  confirmationCodeRequest: PropTypes.func,
  t: PropTypes.func.isRequired,
};
